import { GoogleTagManager } from '@rosetta/rs-google';
import React from 'react';

const FB_GTM_CONTAINER_ID = 'GTM-WSH65X6';

export const FBGoogleTagManager = React.memo(() => {
  // Render through a portal, so at top most level of the DOM in the same spot always.
  return <GoogleTagManager gtm_id={FB_GTM_CONTAINER_ID} />;
});
